exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#tree-conciliacion-options .list-group .list-group-item, #tree-conciliacion-options-collapsed .list-group .list-group-item {\n  background-color: rgba(255, 146, 0, 0.05); }\n  #tree-conciliacion-options .list-group .list-group-item.active, #tree-conciliacion-options-collapsed .list-group .list-group-item.active {\n    background-color: rgba(255, 146, 0, 0.25);\n    color: black; }\n\n#tree-conciliacion-options .conciliacion-option, #tree-conciliacion-options-collapsed .conciliacion-option {\n  cursor: pointer; }\n\n#tree-conciliacion-options-collapsed {\n  display: none;\n  z-index: 999999999; }\n  #tree-conciliacion-options-collapsed.display {\n    display: block; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src14910448/src/src/app/components/navigation/options/conciliacion/conciliacion-option.component.scss
// module id = ../../../../../src/app/components/navigation/options/conciliacion/conciliacion-option.component.scss
// module chunks = main